<template>
  <div class="row" v-if="(this.$store.state.requirements['email'] && (type === 'Registration' || type === undefined)) || this.$store.state.requirements['passport'] || this.$store.state.requirements['phone'] || (this.$store.state.requirements['driver_license_number'] && (type === 'Registration' || type === undefined)) || this.$store.state.requirements['social_number'] && (type === 'Registration' || type === undefined)">
    <div class="col-md-12" :class="[validatedSectionClass, generalClass]">
  <!--    email-->
    <div v-if="type === 'Registration' || type === undefined" class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label for="email" :class="modelValidations.email.required ? 'required' : '' "
                              class="control-label">
            {{computeReportableCaption(this.$store.state.requirements['email']['reportable_name'], this.fields_en['email'], this.$store.state.lang.value.toLowerCase())}}
          </label>
          <input :disabled="type === 'Registration'"
                 type="email"
                 name="email"
                 id="email"
                 ref="email"
                 data-vv-as="Email"
                 v-validate="modelValidations.email"
                 v-model="model.email"
                 class="form-control">
          <div class="default-grey font-small" v-show="getFieldDescription('email')" v-html="getFieldDescription('email') || ''"></div>
          <small class="text-danger" v-show="email.invalid">
            {{ computeCaption(getError("email"), $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>
    <!--  confirmation  email-->
    <div v-if="type === undefined" class="row">
    <div
      v-if="this.$store.state.configs.DOUBLE_ENTRY_EMAIL && this.$store.state.requirements['email']"
    >
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label
            for="confirmation_email"
            :class="
              modelValidations.email.required
                ? 'required'
                : ''
            "
            class="control-label"
          >
            {{computeCaption(this.fields_en['confirmation_email'], this.$store.state.lang.value.toLowerCase())}}
          </label>
          <input
            type="email"
            id="confirmation_email"
            data-vv-as="Confirmation Email"
            @paste.prevent
            name="confirmation_email"
            v-validate="'confirmed:email'"
            v-model="model.confirmation_email"
            class="form-control"
          />
          <small class="text-danger" v-show="confirmation_email.invalid">
            {{ computeCaption(getError("confirmation_email"), $store.state.lang.value.toLowerCase())}}
          </small>
          <small class="text-danger" v-show="confirmation_email_error">
            {{ computeCaption(this.confirmation_email_error, $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>
    </div>
    <!--Phautocomplete="off"one && passport-->
    <div v-if="this.$store.state.requirements['phone'] && this.$store.state.requirements['passport']" class="row">
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label"  :class="modelValidations.phone['required'] ? 'required' : ''" for="phone">
            {{computeReportableCaption($store.state.requirements['phone']['reportable_name'], fields_en['phone'], $store.state.lang.value.toLowerCase())}}
          </label>
          <input id="phone" v-if="this.$store.state.international === false"
                 class="form-control phone-cleave-format"
                 autocomplete="off"
                 type="tel"
                 data-vv-as="Phone"
                 name="phone"
                 @input="changePhone"
                 v-validate="modelValidations.phone"
                 v-model="model.phone"
                 v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                 placeholder="ex: (954) 000-0000"
                 maxlength="14"
          />
          <vue-tel-input v-else
          name="intPhone"
          ref="intPhone"
          v-model="internationalPhone"
          class="form-control phone-cleave-format border-color"
          :valid-characters-only="true"
          :input-options=inputOptions
          @validate="validatePhone">
            <template v-slot:arrow-icon>
              <span>{{ open ? '▲' : '▼' }}</span>
            </template>
          </vue-tel-input>
          <div class="default-grey font-small" v-show="getFieldDescription('phone')" v-html="getFieldDescription('phone') || ''"></div>
          <small class="text-danger" v-show="phone.invalid">
            {{computeCaption(getError("phone"), this.$store.state.lang.value.toLowerCase())}}
          </small>
          <small class="text-danger" v-if="computeCaption(errorIntPhone, this.$store.state.lang.value.toLowerCase())">
            {{ computeCaption(errorIntPhone, this.$store.state.lang.value.toLowerCase()) }}
          </small>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label for="passport" :class="modelValidations.passport.required ? 'required' : '' " class="control-label">
            {{computeReportableCaption(this.$store.state.requirements['passport']['reportable_name'], this.fields_en['passport'], this.$store.state.lang.value.toLowerCase())}}
          </label>
          <input type="text"
                 name="passport"
                 id="passport"
                 ref="passport"
                 data-vv-as="Passport"
                 v-validate="modelValidations.passport"
                 v-model="model.passport"
                 :key="passportKeyNumber"
                 class="form-control"
                 onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
          <div class="default-grey font-small" v-show="getFieldDescription('passport')" v-html="getFieldDescription('passport') || ''"></div>
          <small class="text-danger" v-show="passport.invalid">
            {{computeCaption(getError("passport"), this.$store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>

    <div v-if="(this.$store.state.requirements['phone'] === undefined || this.$store.state.requirements['phone'] === '') && this.$store.state.requirements['passport']" class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label for="passport" :class="modelValidations.passport.required ? 'required' : '' " class="control-label">
            {{computeReportableCaption(this.$store.state.requirements['passport']['reportable_name'], this.fields_en['passport'], this.$store.state.lang.value.toLowerCase())}}
          </label>
          <input type="text"
                 name="passport"
                 id="passport"
                 ref="passport"
                 data-vv-as="Passport"
                 v-validate="modelValidations.passport"
                 v-model="model.passport"
                 :key="passportKeyNumber+1"
                 class="form-control"
                 onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
          <div class="default-grey font-small" v-show="getFieldDescription('passport')" v-html="getFieldDescription('passport') || ''"></div>
          <small class="text-danger" v-show="passport.invalid">
            {{computeCaption(getError("passport"), this.$store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>

    <div v-if="this.$store.state.requirements['phone'] && (this.$store.state.requirements['passport'] === undefined || this.$store.state.requirements['passport'] === '')" class="row">
      <div class="col-md-10 col-md-offset-1">
         <div class="form-group">
          <label class="control-label"  :class="modelValidations.phone['required'] ? 'required' : ''" for="phone1">
            {{computeReportableCaption($store.state.requirements['phone']['reportable_name'], fields_en['phone'], $store.state.lang.value.toLowerCase())}}
          </label>
          <input v-if="this.$store.state.international === false"
                 class="form-control phone-cleave-format"
                 autocomplete="off"
                 id="phone1"
                 type="tel-national"
                 data-vv-as="Phone"
                 name="phone"
                 @input="changePhone"
                 v-validate="modelValidations.phone"
                 v-model="model.phone"
                 v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                 placeholder="ex: (954) 000-0000"
                 maxlength="14"
          />
          <vue-tel-input v-else
          name="intPhone"
          ref="intPhone"
          v-model="internationalPhone"
          class="form-control phone-cleave-format border-color"
          :valid-characters-only="true"
          :input-options=inputOptions
          @validate="validatePhone">
            <template v-slot:arrow-icon>
              <span>{{ open ? '▲' : '▼' }}</span>
            </template>
          </vue-tel-input>
          <div class="default-grey font-small" v-show="getFieldDescription('phone')" v-html="getFieldDescription('phone') || ''"></div>
          <small class="text-danger" v-show="phone.invalid">
            {{computeCaption(getError("phone"), this.$store.state.lang.value.toLowerCase())}}
          </small>
          <small class="text-danger" v-if="errorIntPhone">
            {{computeCaption(errorIntPhone, this.$store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>

    <div v-if="this.$store.state.requirements['social_number'] && (type === 'Registration' || type === undefined)" class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label class="control-label"
                 :class="modelValidations.med_social_security_number['required'] ? 'required' : ''">
            {{computeCaption(this.fields_en['med_social_security_number'], this.$store.state.lang.value.toLowerCase())}}
          </label>
          <input class="form-control ssn-cleave-format"
                 autocomplete="off"
                 type="text"
                 data-vv-as="Social Security Number"
                 name="med_social_security_number"
                 v-validate="modelValidations.med_social_security_number"
                 v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                 v-model="model.med_social_security_number"
          />
          <div class="default-grey font-small" v-show="getFieldDescription('social_number')" v-html="getFieldDescription('social_number') || ''"></div>
          <small class="text-danger" v-show="med_social_security_number.invalid">
            {{computeCaption(getError("med_social_security_number"), this.$store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>
    <!-- Driver License number -->
    <div v-if="this.$store.state.requirements['driver_license_number'] && (type === 'Registration' || type === undefined)" class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label class="control-label"
                 :class="modelValidations.med_driver_license_number['required'] ? 'required' : ''">
            {{computeCaption(this.fields_en['med_driver_license_number'], this.$store.state.lang.value.toLowerCase())}}
          </label>
          <input class="form-control"
                 autocomplete="off"
                 type="text"
                 data-vv-as="Driver License Number"
                 name="med_driver_license_number"
                 v-validate="modelValidations.med_driver_license_number"
                 v-model="model.med_driver_license_number"
                 onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
          />
          <div class="default-grey font-small" v-show="getFieldDescription('driver_license_number')" v-html="getFieldDescription('driver_license_number') || ''"></div>
          <small class="text-danger" v-show="med_driver_license_number.invalid">
            {{computeCaption(getError("med_driver_license_number"), this.$store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import {mapFields} from 'vee-validate'
import Cleave from 'cleave.js'
import {ValidationUtils} from '../../../../utils/Validation'
import {FormatterUtils} from '../../../../utils/Formatter.js'
import {TranslationsUtils} from '../../../../utils/Translations.js'
import {SettingsUtils} from '../../../../utils/SiteConfigurations'
import {AccessionUtils} from '../../../../utils/AccessionDetailsProcessing'
require('cleave.js/dist/addons/cleave-phone.us')
export default {
  mixins: [FormatterUtils, ValidationUtils, TranslationsUtils, SettingsUtils, AccessionUtils],
  props: ['type', 'configuration', 'triggerPersonIdentifierWatch'],
  data () {
    return {
      confirmation_email_error: '',
      token: localStorage.getItem('token') || '',
      generalClass: 'general-inactive-section',
      triggerValidation: false,
      validatedSectionClass: '',
      personIdentifierSectionValidation: {
        emailValidation: this.checkToken(localStorage.getItem('token')),
        confirmationEmailValdidation: !this.$store.state.configs.DOUBLE_ENTRY_EMAIL,
        phoneValidation: !this.checkRequirement('phone'),
        passportValidation: !this.checkRequirement('passport'),
        ssnValidation: !(this.checkRequirement('social_number') && (this.type === 'Registration' || this.type === undefined)),
        dlnValidation: !(this.checkRequirement('driver_license_number') && (this.type === 'Registration' || this.type === undefined))
      },
      open: false,
      mailError: '',
      inputOptions: {styleClasses: 'border-color'},
      internationalPhone: '',
      errorIntPhone: '',
      intPhone: {
        number: '',
        isValid: false
      },
      allow_driver_license: this.$store.state.configs.ALLOW_DRIVER_LICENSE,
      passportKeyNumber: 999999,
      fields_en: {
        med_driver_license_number: 'Driver License Number',
        med_social_security_number: 'Social Security Number',
        driver_license: 'Driver License',
        passport: 'Passport',
        email: 'Email',
        phone: 'Phone',
        driver_license_number: 'Driver license number',
        social_security_number: 'Social Security Number',
        confirmation_email: 'Confirmation email'
      },
      model: {
        med_driver_license_number: '',
        med_social_security_number: '',
        passport: '',
        email: '',
        phone: '',
        driver_license_number: '',
        social_security_number: '',
        confirmation_email: ''
      },
      modelValidations: {
        passport: {
          min: 6,
          max: 15,
          required: this.checkRequirement('passport')
        },
        email: {
          required: true,
          email: true
        },
        confirmation_email: {
          email: true
        },
        phone: {
          required: this.checkRequirement('phone'),
          min: 14,
          regex: '^(?:(?:\\+?1\\s*(?:[.-]\\s*)?)?(?:\\(\\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\\s*\\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\\s*(?:[.-]\\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\\s*(?:[.-]\\s*)?([0-9]{4})(?:\\s*(?:#|x\\.?|ext\\.?|extension)\\s*(\\d+))?$'
        },
        driver_license_number: {
        },
        social_security_number: {
          min: 11,
          max: 11
        },
        med_social_security_number: {
          required: this.checkRequirement('social_number'),
          min: 11,
          max: 11
        },
        med_driver_license_number: {
          required: this.checkRequirement('driver_license_number')
        }
      },
      nationality: 'US'
    }
  },
  methods: {
    computePersonIdentifierValidationObject () {
      if (Object.values(this.personIdentifierSectionValidation).every(field => field === true)) {
        this.validatedSectionClass = 'validated-section-class'
        this.generalClass = 'general-inactive-section'
      } else {
        this.validatedSectionClass = 'invalid-section-class'
        this.generalClass = 'general-invalid-section'
      }
    },
    validatePhone (phoneObject) {
      this.errorIntPhone = ''
      if (phoneObject.valid) {
        this.intPhone.number = phoneObject.number
        this.intPhone.isValid = phoneObject.valid
      } else {
        this.intPhone.isValid = false
      }
    },
    checkToken (token) {
      if (!token) {
        return false
      }
      return true
    },
    changePhone () {
      this.phoneTransaction = false
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    async validate () {
      await this.$validator.validateAll()
      if (this.$validator.errors.items.length && (this.$validator.errors.items[0].field === 'phone' || this.$validator.errors.items[0].field === 'email')) {
        document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
        this.$store.state.medDataValidator = false
      }
      if (this.checkRequirement('passport')) {
        if (this.model.passport === '') {
          document.getElementsByName('passport')[0].focus()
          return false
        }
      }
      if (this.checkRequirement('social_number') && (this.type === 'Registration' || this.type === undefined)) {
        if (this.model.med_social_security_number === '') {
          document.getElementsByName('med_social_security_number')[0].focus()
          return false
        }
      }
      if (this.checkRequirement('driver_license_number') && (this.type === 'Registration' || this.type === undefined)) {
        if (this.model.med_driver_license_number === '') {
          document.getElementsByName('med_driver_license_number')[0].focus()
          return false
        }
      }
      this.errorIntPhone = ''
      if (this.checkRequirement('phone') && this.$store.state.international) {
        if (!this.intPhone.number) {
          this.errorIntPhone = 'The Phone field is required'
          this.$refs.intPhone.$refs.input.focus()
          return false
        } else if (!this.intPhone.isValid && this.intPhone.number) {
          this.errorIntPhone = 'The Phone field is invalid'
          this.$refs.intPhone.$refs.input.focus()
          return false
        } else if (this.intPhone.isValid && this.intPhone.number) {
          this.model.phone = this.intPhone.number
        }
      }
      if (this.model.email) {
        if (this.restrictEmail) {
          if (!this.model.email.endsWith('@' + this.restrictEmail)) {
            this.mailError = 'Email not accepted by Office Location Code'
            document.getElementsByName('email')[0].focus()
            return false
          }
        }
        if (this.$store.state.configs.DOUBLE_ENTRY_EMAIL === true && this.type === undefined) {
          if (this.model.confirmation_email === '') {
            this.confirmation_email_error = 'This field is required'
            document.getElementsByName('confirmation_email')[0].focus()
            return false
          }
          if (this.model.email !== this.model.confirmation_email) {
            document.getElementsByName('confirmation_email')[0].focus()
            return false
          }
        }
      }
      if ((await this.$validator.validateAll() === true) && this.errorIntPhone === '') {
        this.configuration.model.passport = this.model.passport
        this.configuration.model.email = this.model.email
        this.configuration.model.phone = this.model.phone
        this.configuration.model.driver_license_number = this.model.driver_license_number
        this.configuration.model.social_security_number = this.model.social_security_number
        this.configuration.model.med_driver_license_number = this.model.med_driver_license_number
        this.configuration.model.med_social_security_number = this.model.med_social_security_number
        return true
      }
      return false
    }
  },
  async beforeMount () {
    if (this.token) {
      this.model.passport = this.$store.state.userData['passport'] || ''
      this.model.phone = this.$store.state.userData['phone'] || ''
      this.model.med_driver_license_number = this.$store.state.userData['driver_license_number'] || ''
      this.model.social_security_number = this.$store.state.userData['social_number'] || ''
      this.model.med_social_security_number = this.$store.state.userData['social_number'] || ''
      this.model.email = localStorage.getItem('email')
    }
  },
  mounted () {
    if (this.triggerPersonIdentifierWatch === true) {
      if (this.type === 'personalData' || this.type === 'dependentRegistration') {
        if (this.$store.state.requirements['phone'] !== '' || this.$store.state.requirements['passport'] !== '') {
          // do not start the watch if type is personalData and passport/phone are empty
          if (this.model.phone !== '' || this.model.passport !== '') {
            this.$watch('personIdentifierSectionValidation', this.computePersonIdentifierValidationObject, {deep: true})
          }
        }
      } else {
        this.$watch('personIdentifierSectionValidation', this.computePersonIdentifierValidationObject, {deep: true})
      }
    }
  },
  computed: {
    emailFromTransaction () {
      if (this.$store.state.medicalData.email) {
        return this.$store.state.medicalData.email
      }
    },
    phoneFromTransaction () {
      if (this.$store.state.medicalData.phone) {
        return this.$store.state.medicalData.phone
      }
    },
    ...mapFields(['email', 'confirmation_email', 'phone', 'passport', 'social_security_number', 'driver_license_number', 'med_driver_license_number', 'med_social_security_number'])
  },
  watch: {
    '$store.state.international': {
      handler: function (after, before) {
        this.validatedSectionClass = ''
      }
    },
    'triggerValidation': {
      handler: function (value) {
        this.$watch('personIdentifierSectionValidation', this.computePersonIdentifierValidationObject, {deep: true})
      }
    },
    'model.phone': {
      handler: function (after, before) {
        this.triggerValidation = true
        after = after.replace(/\D/g, '').slice(-10)
        if (this.phoneTransaction) {
          this.model.phone = '(' + this.phoneFromTransaction.substring(0, 3) + ') ' + this.phoneFromTransaction.substring(3, 6) + '-' + this.phoneFromTransaction.substring(6, 10)
          this.configuration.model.phone = this.model.phone
        } else {
          if (this.nationality !== 'International' && after.length !== 14) {
//            if (after.length >= 10) {
//              after = after.substring(after.length - 10, after.length)
//            }
            let phoneElements = document.getElementsByClassName('phone-cleave-format')
            if (!phoneElements.length) {
              return
            }
            let self = this
            let phoneCleave = new Cleave('.phone-cleave-format', {
              numericOnly: true,
              delimiters: ['(', ')', ' ', '-'],
              blocks: [0, 3, 0, 3, 4],
              onValueChanged: function (e) {
                e.target.rawValue = after
                if (e.target.value.length === 14) {
                  self.model.phone = e.target.value
                }
              }
            })
            phoneCleave.setRawValue(after)
            this.configuration.model.phone = this.model.phone
          }
        }
        if (this.modelValidations.phone.required) {
          if (this.nationality !== 'International') {
            let reg = new RegExp(this.modelValidations.phone.regex)
            if (this.model.phone.length > this.modelValidations.phone.min - 1 && reg.test(this.model.phone)) {
              this.configuration.model.phone = this.model.phone
              this.personIdentifierSectionValidation.phoneValidation = true
            } else {
              this.personIdentifierSectionValidation.phoneValidation = false
            }
          }
        } else {
          this.personIdentifierSectionValidation.phoneValidation = true
        }
      },
      deep: true
    },
    'intPhone': {
      handler: function (after, before) {
        if (this.intPhone.isValid && this.intPhone.number) {
          this.personIdentifierSectionValidation.phoneValidation = true
          this.configuration.model.phone = this.intPhone
        } else {
          this.personIdentifierSectionValidation.phoneValidation = false
        }
      },
      deep: true
    },
    'model.med_social_security_number': {
      handler: function (after, before) {
        if (before) {
          let ssnCleave = new Cleave('.ssn-cleave-format', {
            delimiters: ['-', '-'],
            numericOnly: true,
            uppercase: true,
            blocks: [3, 2, 4]
          })
          this.model.med_social_security_number = ssnCleave.getFormattedValue()
        }
        if (this.type === 'Registration' || this.type === undefined) {
          if (this.model.med_social_security_number.length === this.modelValidations.social_security_number.max) {
            let dummyData = {
              med_social_security_number: this.model.med_social_security_number,
              med_driver_license_number: this.model.med_driver_license_number
            }
            this.$store.state.personIdentifierSection = dummyData
          }
        }
        this.configuration.model.med_social_security_number = this.model.med_social_security_number
        if (this.modelValidations.med_social_security_number.required) {
          if (this.model.med_social_security_number.length > this.modelValidations.med_social_security_number.min - 1 && this.model.med_social_security_number.length <= this.modelValidations.med_social_security_number.max) {
            this.personIdentifierSectionValidation.ssnValidation = true
          } else {
            this.personIdentifierSectionValidation.ssnValidation = false
          }
        } else {
          this.personIdentifierSectionValidation.ssnValidation = true
        }
      },
      deep: true
    },
    '$store.state.requirements': {
      handler: function (after, before) {
        this.modelValidations.phone.required = this.checkRequirement('phone')
        this.modelValidations.passport.required = this.checkRequirement('passport')
        this.modelValidations.med_social_security_number.required = this.checkRequirement('social_number')
        this.modelValidations.med_driver_license_number.required = this.checkRequirement('driver_license_number')
        this.personIdentifierSectionValidation = {
          emailValidation: this.checkToken(localStorage.getItem('token')),
          confirmationEmailValdidation: !this.$store.state.configs.DOUBLE_ENTRY_EMAIL,
          phoneValidation: !this.checkRequirement('phone'),
          passportValidation: !this.checkRequirement('passport'),
          ssnValidation: !(this.checkRequirement('social_number') && (this.type === 'Registration' || this.type === undefined)),
          dlnValidation: !(this.checkRequirement('driver_license_number') && (this.type === 'Registration' || this.type === undefined))
        }
        this.$watch('personIdentifierSectionValidation', this.computePersonIdentifierValidationObject, {deep: true})
      },
      deep: true
    },
    'model.passport': {
      handler: function (after, before) {
        this.triggerValidation = true
        this.configuration.model.passport = this.model.passport
        if (this.modelValidations.passport.required) {
          if (this.model.passport.length > this.modelValidations.passport.min - 1 && this.model.passport.length <= this.modelValidations.passport.max) {
            this.personIdentifierSectionValidation.passportValidation = true
          } else {
            this.personIdentifierSectionValidation.passportValidation = false
          }
        } else {
          this.personIdentifierSectionValidation.passportValidation = true
        }
      },
      deep: true
    },
    'model.email': {
      handler: function (before, after) {
        if (this.mailError !== '') {
          this.mailError = ''
        }
        if (!this.token) {
          if (this.modelValidations.email.required) {
            let emailRegEx = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
            if (emailRegEx.test(this.model.email)) {
              this.personIdentifierSectionValidation.emailValidation = true
              this.configuration.model.email = this.model.email
            } else {
              this.personIdentifierSectionValidation.emailValidation = false
            }
          } else {
            this.personIdentifierSectionValidation.emailValidation = true
          }
          if (this.$store.state.configs.DOUBLE_ENTRY_EMAIL === true && this.type === undefined) {
            if (this.model.email === this.model.confirmation_email) {
              this.personIdentifierSectionValidation.confirmationEmailValdidation = true
            } else {
              this.personIdentifierSectionValidation.confirmationEmailValdidation = false
            }
          }
        } else {
          this.personIdentifierSectionValidation.confirmationEmailValdidation = true
        }
      }
    },
    'model.confirmation_email': {
      handler: function (before, after) {
        if (this.$store.state.configs.DOUBLE_ENTRY_EMAIL === true) {
          if (this.model.confirmation_email === '') {
            this.confirmation_email_error = 'This field is required'
            this.personIdentifierSectionValidation.confirmationEmailValdidation = false
          } else {
            this.confirmation_email_error = ''
            this.personIdentifierSectionValidation.confirmationEmailValdidation = true
          }
          if (this.model.confirmation_email === this.model.email) {
            this.personIdentifierSectionValidation.confirmationEmailValdidation = true
          } else {
            this.personIdentifierSectionValidation.confirmationEmailValdidation = false
          }
        }
      }
    },
    emailFromTransaction () {
      this.model.email = this.$store.state.medicalData.email
      this.model.confirmation_email = this.$store.state.medicalData.email
    },
    phoneFromTransaction () {
      this.model.phone = this.$store.state.medicalData.phone
      this.phoneTransaction = true
    },
    'model.med_driver_license_number': {
      handler: function (after, before) {
        if (this.model.med_driver_license_number === '') {
          this.driverLicNrKey += 1
        }
        if (this.type === 'Registration' || this.type === undefined) {
          if (this.model.med_social_security_number.length === this.modelValidations.social_security_number.max) {
            let dummyData = {
              med_social_security_number: this.model.med_social_security_number,
              med_driver_license_number: this.model.med_driver_license_number
            }
            this.$store.state.personIdentifierSection = dummyData
          } else {
            let dummyData = {
              med_social_security_number: '',
              med_driver_license_number: this.model.med_driver_license_number
            }
            this.$store.state.personIdentifierSection = dummyData
          }
        }
        this.configuration.model.med_driver_license_number = this.model.med_driver_license_number
        if (this.modelValidations.med_driver_license_number.required) {
          if (this.model.med_driver_license_number) {
            this.personIdentifierSectionValidation.dlnValidation = true
          } else {
            this.personIdentifierSectionValidation.dlnValidation = false
          }
        } else {
          this.personIdentifierSectionValidation.dlnValidation = true
        }
      },
      deep: true
    },
    '$store.state.restrict_email_to_domain': {
      handler: function (before, after) {
        this.restrictEmail = this.$store.state.restrict_email_to_domain
      },
      deep: true
    },
    'triggerPersonIdentifierWatch': {
      handler: function (after, before) {
        this.$watch('personIdentifierSectionValidation', this.computePersonIdentifierValidationObject, {deep: true})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/sass/paper/_variables.scss";

  .border-color{
    border-color: #9A9A9A !important;
  }

  .border-color *:focus{
    border-color: #e8b39c !important;
  }

  .border-color:focus-within{
    border-color: #e8b39c !important;
    box-shadow: none;
  }

  .general-inactive-section:focus-within {
    border-left-color: $primary-color !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/PersonIdentifierSection.vue